import React, { useState, useEffect } from "react";
import SectionTitle from "../../../components/SectionTitle";
import * as Icon from "react-bootstrap-icons";
import { getPostDate } from "../../../utils/date";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import NoticesPlaceholder from "./placeholders/NoticesPlaceholder";
import { getContent } from "../../../utils/main";

export const RightPart = () => {
  const content = useSelector((state) => state.mainSlice.content);
  const lang = useSelector((state) => state.mainSlice.lang);
  const [isNoticesLoading, setIsNoticesLoading] = useState(true);
  const [notices, setNotices] = useState([]);
  const [page, setPage] = useState(1);
  const size = 1;

  const loadMore = () => {
    setIsNoticesLoading(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}/api/v1/notices/list/?size=${size}&page=${page}`
      )
      .then((res) => {
        setNotices([...notices, ...res.data["results"]]);
        if (size * page < res.data["count"]) {
          setPage(page + 1);
        } else {
          setPage(0);
        }
      })
      .then(() => {
        setIsNoticesLoading(false);
      });
  };

  useEffect(() => {
    loadMore();
  }, []);

  return (
    <div className="col-lg-4 col-md-4 col-sm-12 col-xs-12">
      <SectionTitle
        text={getContent(content, "Other announcements", lang)}
        color={"#1e73be"}
      />
      {notices.map((notice) => (
        <Link to={`/notices/${notice.slug}`} key={notice.id}>
          <p className="news-title-one two">
            <span className="underline-animation-on-hover">
              {lang === "en"
                ? (notice.name_en.substring(0, 70) ?? " ") +
                  (notice.name_en.length > 70 ? "..." : "")
                : lang === "ru"
                ? (notice.name_ru.substring(0, 70) ?? " ") +
                  (notice.name_ru.length > 70 ? "..." : "")
                : (notice.name_tm.substring(0, 70) ?? " ") +
                  (notice.name_tm.length > 70 ? "..." : "")}
            </span>
          </p>
          <p className="news-date">
            {getPostDate(notice.pub_date)} &nbsp; <Icon.Eye /> {notice.views}
          </p>
        </Link>
      ))}
      {isNoticesLoading === true ? (
        <NoticesPlaceholder />
      ) : page !== 0 ? (
        <button
          className="clear-btn black-btn m-auto d-block"
          onClick={() => loadMore()}
        >
          {getContent(content, "Load more", lang)}
        </button>
      ) : (
        ""
      )}
    </div>
  );
};
